import * as React from 'react';
import classNames from 'classnames';
import styles from './CookiebotRenew.module.esm.js';

var CookiebotRenew = function (_a) {
    var text = _a.text;
    return (React.createElement("li", null,
        React.createElement("button", { className: classNames(styles.renew, 'nv-plain-action'), onClick: function () { return Cookiebot.renew(); } }, text)));
};

export { CookiebotRenew as default };
//# sourceMappingURL=CookiebotRenew.esm.js.map
